import type { IOffer } from '~/interfaces/product/IProductPageData';
import {useProductStore} from "~/store/product/productStore";

interface IVariantSelectorState {
  isOpen: boolean,
  selectedVariant: IOffer|null
}

export const useVariantSelectorStore = defineStore({
  id: 'variantSelector',
  state: (): IVariantSelectorState => ({
    isOpen: false,
    selectedVariant: null
  }),
  getters: {
    currentVariant(state) {
      const productStore = useProductStore();
      if (productStore.wasOffer) {
        const item = productStore.variantCollection.find(obj => obj.canonicalMerchantProduct.id === productStore.offer.canonicalMerchantProduct.id);
        if (!item) return null;
        state.selectedVariant = item;
        return item;
      }

      if (productStore.variantCollection.length === 1) {
        state.selectedVariant = productStore.variantCollection[0];
        return productStore.variantCollection[0];
      }

      return state.selectedVariant;
    }
  },
  actions: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    }
  },
});
